import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import type {Language, CustomerUser} from '@/types'
import RawPermissionsBox from './user-permissions'

import './index.css'

type Props = {
  l: Language,
  userList: Array<CustomerUser>,
  changeUserPermissions: (Array) => void,
  isFetched: boolean,
  onRevokeAll: (any) => void,
  revokeAll: boolean,
  showRevokeAll: boolean,
}

export class RawUsersBox extends Component<Props> {
  changePermissions = (data: string, id: number) => {
    let users = this.props.userList
    users = users.map((user) => {
      if (user.userId === id) {
        user.permissions = data
      }
      return user
    })
    this.props.changeUserPermissions(users)
  }

  getPermissions = (permissionsString: string) => {
    let permissions = permissionsString.split(',')
    if (permissions.length > 0 && permissions[0].trim() !== '') {
      permissions = permissions.map((text) => text.trim())
      if (permissions.indexOf('View') === -1) {
        permissions.push('View')
      }
    } else {
      permissions = []
    }
    return permissions
  }

  getClassName = () => this.props.userList.length > 10 ? 'users-section' : ''

  renderUsers = () => {
    if (this.props.isFetched) {
      if (this.props.userList.length > 0) {
        return this.props.userList.map((user: CustomerUser, index) => {
          return (
            <div className='col-md-12 permissions-box' key={index}>
              <div className='col-md-3 username'>{user.userName}</div>
              <div>
                <RawPermissionsBox permissions={this.getPermissions(user.permissions)} id={user.userId}
                  setPermissions={this.changePermissions} disableAll={this.props.revokeAll}/>
              </div>
            </div>
          )
        })
      } else {
        return (<div className='text-center'>{this.props.l('There are no users')}.</div>)
      }
    }
  }

  renderRevokeAll = () => {
    if (this.props.showRevokeAll) {
      return (
        <div className='revoke-all-checkbox btn-group' data-toggle='buttons'>
          <label className={this.props.revokeAll ? 'btn btn-success' : 'btn btn-default'}>
            <input type="checkbox" checked={this.props.revokeAll} onChange={this.props.onRevokeAll}/>
            {this.props.l('Revoke all')}
          </label>
        </div>
      )
    }
    return null
  }

  render = () =>
    <div>
      <div className='col-md-12 users-header'>
        <div className='col-md-3'><h4>{this.props.l('Users')}</h4></div>
        {this.renderRevokeAll()}
      </div>
      <div className={this.getClassName()}>{this.renderUsers()}</div>
    </div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawUsersBox)



// WEBPACK FOOTER //
// ./src/views/forms/share-portfolio/users.js